import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "routes/auth";

export default function ProtectedRoute() {
  const hasSession = isAuthenticated();
  const location = useLocation();

  if (!hasSession) {
    return (
      <Navigate to="/login" replace state={{ from: location }} />
    );
  }

  return <Outlet />;
}
